export enum OrderPaymentMethod {
  CREDIT_CARD = 'credit_card',
  BILLET = 'billet',
  PIX = 'pix'
}

export const OrderPaymentMethodLabels = {
  [OrderPaymentMethod.CREDIT_CARD]: 'Cartão de Crédito',
  [OrderPaymentMethod.BILLET]: 'Boleto',
  [OrderPaymentMethod.PIX]: 'PIX',
}